import "chartjs-plugin-annotation";
import React, { Component, PropTypes } from "react";
import { Scatter } from "react-chartjs-2";
import FullscreenWrapper from "../chart-fullscreen-wrapper/chart-fullscreen-wrapper";
import drawAliasOrNameLabelPlugin from "../chart-plugins/drawAliasOrNameLabel";
import drawInclinationLabelPlugin from "../chart-plugins/drawInclinationLabel";
import RangeInput from "./range-input";
import { getRangeLimitsFromInstance, checkRangeLimits, adjustRangeConstraints } from '../measurement-chart-group/getNextDataUtils.js';

const oneDayMs = 86400000;
const oneWeekMs = oneDayMs * 7;

//const service = abp.services.api.measurementChartService;
const api = abp.services.api.measurementChartClientApi;

class MeasurementChart extends Component {
    static propTypes = {
        // from view
        options: PropTypes.object.isRequired,
        data: PropTypes.object,
        height: PropTypes.number,
        legendDivId: PropTypes.string,
        // events 
        onRangeChanged: PropTypes.func.isRequired,
        onPlotVisibilityChanged: PropTypes.func,
        onChartLegendCallback: PropTypes.func,
        registerRangeReference: PropTypes.func,
        registerChartReference: PropTypes.func,
        isLongitudinalProfileChart: PropTypes.bool,
        getHiddenPointIds: PropTypes.func,
        getHiddenDatasets: PropTypes.func,
        useLiveDataAccessor: PropTypes.bool,
        profileId: PropTypes.number
    };

    state = {
        dataIsLoading: false
    }

    componentWillMount() {
        Chart.pluginService.register({
            afterDatasetsDraw: (chart) => {
                drawInclinationLabelPlugin(chart);
                drawAliasOrNameLabelPlugin(chart);
            },
        });

        if (this.props.registerChartReference) {
            this.props.registerChartReference(this);
        }
    }

    componentDidMount = () => {
        const { legendDivId, getHiddenPointIds, getHiddenDatasets } = this.props;

        if (legendDivId) {

            const chart = this.refs.chart.chartInstance;

            var text = [];
            text.push('<ul style="display: flex; flex-flow: row wrap;" class="' + chart.id + '-legend">');
            for (var i = 0; i < chart.data.dataSets.length; i++) {
                let dataSet = chart.data.dataSets[i];
                let color = dataSet.backgroundColor;
                let label = dataSet.label;
                text.push('<li style="list-style: none; padding:6px !important;"><div class="legendValue"><span style="background-color:' + color + '">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>');
                text.push('<span style="padding:6px !important;"class="label">' + label + '</span>');
                text.push('</div></li><div class="clear"></div>');
            }

            text.push('</ul>');
            let html = text.join('');
            $('#' + legendDivId).prepend(html);
            let legend = chart.generateLegend();
        }

        this.setPrintUrl(getHiddenPointIds, getHiddenDatasets);
    }

    scaling = {
        horizontalAxisMin: null,
        horizontalAxisMax: null,
        verticalAxisMin: null,
        verticalAxisMax: null,
        minXloaded: null,
        maxXloaded: null
    };

    verticalRange = null;
    horizontalRange = null;

    registerVerticalRange = (instance) => {
        this.verticalRange = instance;
    }

    registerHorizontalRange = (instance) => {
      this.horizontalRange = instance;
      if (this.props.registerRangeReference) { 
        this.props.registerRangeReference(instance); 
      }
    }

    hiddenPointIds = []
    hiddenDatasets = []

    changeScaling = (changeScale) => {
        const chart = this.refs.chart.chartInstance;
        if (chart) {
            const exportDetailLink = document.querySelector("a#exportDetail");
            const exportLink = document.querySelector("button#export");
            let fireChangeScale = true;
            if (exportDetailLink) {
                //alter URL for export detail page - pass scaling params
                const exportDetailUrl = exportDetailLink.getAttribute("href");
                let altExportDetailUrl = "";
                const scalingExists =
                    exportDetailUrl.indexOf(`scaling_${this.props.options.title.text}=`) !==
                    -1;

                // 1st range selector will be at the top of the page - global date range selector
                // we'll use it for scaling on chainage excavation chart
                const rangeControls = document.querySelector("div.range-controls");
                const rangeInputs = rangeControls.querySelectorAll("input");
                const escavationScalingExists = rangeInputs && rangeInputs.length === 2;

                let urlParams = new URLSearchParams(
                    new URL(location.origin + exportDetailUrl).search
                );

                if (urlParams.has(`scaling_${this.props.options.title.text}`)) {
                    urlParams.set(
                        `scaling_${this.props.options.title.text}`,
                        JSON.stringify(this.scaling)
                    );
                    altExportDetailUrl = `${exportDetailUrl.split("?")[0]
                        }?${decodeURIComponent(urlParams.toString())}`;
                } else
                    altExportDetailUrl = `${exportDetailUrl}&scaling_${this.props.options.title.text}=${JSON.stringify(this.scaling)}`;

                if (exportDetailUrl.indexOf("excavationScaling=") !== -1) {
                    urlParams = new URLSearchParams(
                        new URL(location.origin + altExportDetailUrl).search
                    );
                    urlParams.set(
                        `excavationScaling`,
                        JSON.stringify({
                            start: escavationScalingExists ? rangeInputs[0].value : "",
                            end: escavationScalingExists ? rangeInputs[1].value : "",
                        })
                    );
                    altExportDetailUrl = `${exportDetailUrl.split("?")[0]
                        }?${decodeURIComponent(urlParams.toString())}`;
                } else
                    altExportDetailUrl += `&excavationScaling=${JSON.stringify({
                        start: escavationScalingExists ? rangeInputs[0].value : "",
                        end: escavationScalingExists ? rangeInputs[1].value : "",
                    })}`;

                exportDetailLink.setAttribute("href", altExportDetailUrl);

                if (exportLink) {
                    exportLink.setAttribute("href", altExportDetailUrl);
                }
            } else {
                //we're on the export details, restore scaling
                const searchParams = new URLSearchParams(location.search);
                if (searchParams.has(`scaling_${this.props.options.title.text}`)) {
                    this.scaling = JSON.parse(
                        searchParams.get(`scaling_${this.props.options.title.text}`)
                    );

                    // reverse engineer the existing code
                    const xAxisType = this.getAxisType(true);
                    const yAxisType = this.getAxisType(false);
                    if (xAxisType == "time") {
                      chart.options.scales.xAxes[0][xAxisType].min = moment(searchParams.get(`dateFrom`)).valueOf();
                      chart.options.scales.xAxes[0][xAxisType].max = moment(searchParams.get(`dateTo`)).valueOf();
                    } else {
                      chart.options.scales.xAxes[0][xAxisType].min = this.scaling.horizontalAxisMin;
                      chart.options.scales.xAxes[0][xAxisType].max = this.scaling.horizontalAxisMax;
                    }
                    chart.options.scales.yAxes[0][yAxisType].min = this.scaling.verticalAxisMin;
                    chart.options.scales.yAxes[0][yAxisType].max = this.scaling.verticalAxisMax;

                    fireChangeScale = false; // do not fire changeScale as it will overwrite the new value(s) with old one(s)
                }
            }

            if (fireChangeScale) changeScale(chart.options.scales);

            chart.update();
        }
    };

    getAxisScaling = (getScale) => {
        const chart = this.refs.chart.chartInstance;
        return chart ? getScale(chart.options.scales) : 0;
    };

    notifyScalingChanged = () => {
        this.props.onRangeChanged(this.scaling);
    };

    getAxisType = (xAxis) => {
        const {
            options: {
                scalingControls: { xAxisScalingControl, yAxisScalingControl },
            },
        } = this.props;

        return (xAxis ? xAxisScalingControl : yAxisScalingControl).scalingProperty;
    };

    mapPointData = (point) => {
        return {
            metadata: point.metadata,
            pointId: point.pointId,
            measurementId: point.measurementId,
            x: point.x,
            y: point.y
        };
    }

    isWarningDataset = (dataset) => {
        return ((dataset.measurementTypeId === undefined || dataset.measurementTypeId == 0 /*warning*/) && dataset.data.length == 2);
    }

    adjustWarningDatasetsLimits = (existingDatasets, newDataset, prepend) => {
        existingDatasets.forEach(existingDataset => {
            if (!this.isWarningDataset(existingDataset)) return;
            if (newDataset.data[prepend ? 0 : 1].x == null) return;
            existingDataset.data[prepend ? 0 : 1].x = newDataset.data[prepend ? 0 : 1].x;
        })
    }

    loadNextData = (data, prepend) => {
        const chart = this.refs.chart.chartInstance;
        if (!chart) return;
        let rangeLimits = getRangeLimitsFromInstance(this, 1, true);
        data.forEach(newDataset => {
            if (this.isWarningDataset(newDataset)) {
                this.adjustWarningDatasetsLimits(chart.data.datasets, newDataset, prepend);
                return;
            }
            chart.data.datasets.forEach(existingDataset => {
                if (this.isWarningDataset(existingDataset)) return;
                if (existingDataset.pointId != newDataset.pointId) return;
                if (existingDataset.measurementTypeId != newDataset.measurementTypeId) return;
                if (prepend) {
                    newDataset.data.reverse().filter(point =>
                        existingDataset.data.findIndex(p => p.measurementId == point.measurementId) == -1
                    ).forEach(point => {
                        existingDataset.data.unshift(this.mapPointData(point));
                        checkRangeLimits(rangeLimits, point.y);
                    });
                } else {
                    newDataset.data.filter(point =>
                        existingDataset.data.findIndex(p => p.measurementId == point.measurementId) == -1
                    ).forEach(point => {
                        existingDataset.data.push(this.mapPointData(point));
                        checkRangeLimits(rangeLimits, point.y);
                    })
                }
            })
        });
        adjustRangeConstraints(rangeLimits, this, 1, true);
        chart.update();
    };

    requestNextData = (fromMoment, toMoment, prepend) => {
        this.setState({ dataIsLoading: true })
        api.loadChartData(
            this.props.data.datasets.filter(function (i) { return (i.measurementTypeId !== undefined && i.measurementTypeId != 0) }).map(function (i) { return i.pointId }).join(','),
            fromMoment.format('YYYY-MM-DD'),
            toMoment.format('YYYY-MM-DD'),
            this.props.yParameterTypeIds.join(','),
            this.props.useLiveDataAccessor
        ).done(data => {
            this.loadNextData(data, prepend);
            this.setState({ dataIsLoading: false })
        });
    };

    onRangeChanged = (minVal, maxVal) => {
        const measurementChart = this;
        const axisType = measurementChart.getAxisType(true);
        if (axisType != 'time') return;
        if (maxVal != measurementChart.scaling.horizontalAxisMax) {
            let newVal = moment(maxVal).startOf("day").valueOf();
            measurementChart.scaling.horizontalAxisMax = newVal;
            if (newVal > measurementChart.scaling.maxXloaded) {
              measurementChart.requestNextData(moment(measurementChart.scaling.maxXloaded), moment(newVal), false);
              measurementChart.scaling.maxXloaded = newVal;
            }
            measurementChart.changeScaling((scales) => (scales.xAxes[0][axisType].max = newVal));
        }
        if (minVal != measurementChart.scaling.horizontalAxisMin) {
            let newVal = moment(minVal).startOf("day").valueOf();
            measurementChart.scaling.horizontalAxisMin = newVal;
            if (newVal < measurementChart.scaling.minXloaded) {
                measurementChart.requestNextData(moment(newVal), moment(measurementChart.scaling.minXloaded), true);
                measurementChart.scaling.minXloaded = newVal;
            }
            measurementChart.changeScaling((scales) => (scales.xAxes[0][axisType].min = newVal));
          }
    }

    handleHorizontalMaxChanged = (val) => {
        const measurementChart = this;
        const axisType = measurementChart.getAxisType(true);
        if (axisType == 'time') {
            let newVal = moment(val).startOf("day").valueOf();
            if (newVal > measurementChart.scaling.maxXloaded) return;
            //const adjustedVal = moment(newVal).add(1, 'days').valueOf();
            measurementChart.scaling.horizontalAxisMax = newVal;
            measurementChart.changeScaling((scales) => (scales.xAxes[0][axisType].max = newVal));
        } else {
            measurementChart.scaling.horizontalAxisMax = val;
            measurementChart.changeScaling((scales) => (scales.xAxes[0][axisType].max = val));
        }
    };

    handleHorizontalMinChanged = (val) => {
        const measurementChart = this;
        const axisType = measurementChart.getAxisType(true);
        if (axisType == 'time') {
            let newVal = moment(val).startOf("day").valueOf();
            if (newVal < measurementChart.scaling.minXloaded) return;
            measurementChart.scaling.horizontalAxisMin = newVal;
            measurementChart.changeScaling((scales) => (scales.xAxes[0][axisType].min = newVal));
        } else {
          measurementChart.scaling.horizontalAxisMin = val;
          measurementChart.changeScaling((scales) => (scales.xAxes[0][axisType].min = val));
        }
    };

    handleVerticalMaxChanged = (val) => {
        const axisType = this.getAxisType(false);
        const actualValue = this.getAxisScaling(scales => scales.yAxes[0][axisType].max);
        if (actualValue === val) { return; }
        this.scaling.verticalAxisMax = val;
        this.changeScaling((scales) => (scales.yAxes[0][axisType].max = val));
    };

    handleVerticalMinChanged = (val) => {
        const axisType = this.getAxisType(false);
        const actualValue = this.getAxisScaling(scales => scales.yAxes[0][axisType].min);
        if (actualValue === val) { return; }
        this.scaling.verticalAxisMin = val;
        this.changeScaling((scales) => (scales.yAxes[0][axisType].min = val));
    };

    renderScalingControls = () => {
        const {
            options: {
                scalingControls: { xAxisScalingControl, yAxisScalingControl },
                scales: { xAxes, yAxes },
            },
            data: {
                scalingSettings: {
                    dataXAxisMin,
                    dataXAxisMinPos,
                    dataXAxisMax,
                    dataXAxisMaxPos,
                    dataYAxisMin,
                    dataYAxisMax,
                    lastXAxisMin,
                    lastXAxisMax,
                    lastYAxisMin,
                    lastYAxisMax,
                },
            },
        } = this.props;


        const dataXAxisMinValue = getValueOrDefault(dataXAxisMin, -10);
        const dataXAxisMaxValue = getValueOrDefault(dataXAxisMax, 10);
        const dataXAxisMinPosValue = getValueOrDefault(dataXAxisMinPos, -10);
        const dataXAxisMaxPosValue = getValueOrDefault(dataXAxisMaxPos, 10);
        const dataYAxisMinValue = getValueOrDefault(dataYAxisMin, -10);
        const dataYAxisMaxValue = getValueOrDefault(dataYAxisMax, 10);

        if (this.scaling.horizontalAxisMin == null) {
          this.scaling = {
            horizontalAxisMin: lastXAxisMin || dataXAxisMinValue,
            horizontalAxisMax: lastXAxisMax || dataXAxisMaxValue,
            verticalAxisMin: lastYAxisMin || dataYAxisMinValue,
            verticalAxisMax: lastYAxisMax || dataYAxisMaxValue,
            minXloaded: moment(lastXAxisMin || dataXAxisMinPosValue).startOf("day").valueOf(),
            maxXloaded: moment(lastXAxisMax || dataXAxisMaxPosValue).startOf("day").valueOf()
          };
        }

        return (
            <div className="scaling-controls">
                {xAxisScalingControl && xAxisScalingControl.display && (
                    <RangeInput
                        min={isNaN(dataXAxisMinValue) ? moment(dataXAxisMinValue).add(1, 'days').format('YYYY-MM-DD') : dataXAxisMinValue}
                        max={isNaN(dataXAxisMaxValue) ? moment(dataXAxisMaxValue).add(1, 'days').format('YYYY-MM-DD') : dataXAxisMaxValue}
                        values={[
                            lastXAxisMin || dataXAxisMinPosValue/*dataXAxisMinValue*/,
                            lastXAxisMax || dataXAxisMaxPosValue/*dataXAxisMaxValue*/,
                        ]}
                        step={xAxisScalingControl.stepSize || oneWeekMs}
                        onMaxChanged={this.handleHorizontalMaxChanged}
                        onMinChanged={this.handleHorizontalMinChanged}
                        onParentDateRangeChanged={this.onRangeChanged}
                        onAfterChange={this.notifyScalingChanged}
                        valueIsDate={xAxes.some((x) => x.type === "time")}
                        useDataMax={xAxisScalingControl.useAlwaysDataMax}
                        registerRangeReference={this.registerHorizontalRange}
                        label={xAxisScalingControl.label || "Axis X"}
                    ></RangeInput>
                )}
                {yAxisScalingControl && yAxisScalingControl.display && (
                    <RangeInput
                        min={dataYAxisMinValue}
                        max={dataYAxisMaxValue}
                        values={[
                            lastYAxisMin || dataYAxisMinValue,
                            lastYAxisMax || dataYAxisMaxValue,
                        ]}
                        step={yAxisScalingControl.stepSize || oneWeekMs}
                        onMaxChanged={this.handleVerticalMaxChanged}
                        onMinChanged={this.handleVerticalMinChanged}
                        onAfterChange={this.notifyScalingChanged}
                        valueIsDate={yAxes.some((y) => y.type === "time")}
                        useDataMax={yAxisScalingControl.useAlwaysDataMax}
                        label={yAxisScalingControl.label || "Axis y"}
                        registerYRangeReference={this.registerVerticalRange}
                    ></RangeInput>
                )}
            </div>
        );
    };

    setPrintUrl = (getHiddenPointIds, getHiddenDatasets) => {
        const exportDetailLink = document.querySelector("a#exportDetail");
        if (exportDetailLink) {
            const exportDetailUrl = exportDetailLink.getAttribute("href").split("?")[0];

            let urlParams = new URLSearchParams(new URL(location.origin + exportDetailUrl).search);

            urlParams.set('excludedPointIds', getHiddenPointIds().join());
            urlParams.set('excludedDatasets', getHiddenDatasets().join());

            const exportDetailQuery = exportDetailLink.getAttribute("href").split("?")[1];

            if (exportDetailQuery) {
                const splitted = exportDetailQuery.split("&").filter(s => !s.includes('excludedPointIds') && !s.includes('excludedDatasets'))
                exportDetailLink.setAttribute("href", `${exportDetailUrl}?${urlParams}&${splitted.join('&')}`);
            }
            else {
                exportDetailLink.setAttribute("href", `${exportDetailUrl}?${urlParams}`);
            }
        }
    }

    render = () => {
        const {
            options,
            data,
            height,
            legendDivId,
            onChartLegendCallback,
            onPlotVisibilityChanged,
            getHiddenPointIds,
            getHiddenDatasets
        } = this.props;

        const {
            dataIsLoading
        } = this.state;

        const setPrintUrl = () => {
            this.setPrintUrl(getHiddenPointIds, getHiddenDatasets);
        }

        this.setPrintUrl(getHiddenPointIds, getHiddenDatasets);

        const onPlotVisibilityChangedHandler = function (e, legendItem, legend) {
            onPlotVisibilityChanged(e, legendItem, legend);
            setPrintUrl(getHiddenPointIds, getHiddenDatasets);
        };

        if (onPlotVisibilityChanged /*&& !isLongitudinalProfileChart*/) {
            options.legend.onClick = onPlotVisibilityChangedHandler;
        }

        if (options.tooltips.customText) {
            options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    let tooltipText = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].metadata.tooltipText
                    return tooltipText === undefined ? tooltipItem.yLabel + ", " + tooltipItem.xLabel : tooltipText
                },
            };
        }

        if (legendDivId) {
            options.legend.legendCallback = onChartLegendCallback;
        }

        if (options.scales.xAxes[0].time) {
            // this should be the same as we have on chainage chart, otherwise X scale will be different

            if (options.scales.xAxes[0].time.unit) {
                options.scales.xAxes[0].time.stepSize = 1;
            }

            options.scales.xAxes[0].time.displayFormats = {
                day: "DD.MM.YY",
                week: "DD.MM.YY",
                month: "MM/YY",
                hour: "DD.MM.YY HH:mm"
            };
            options.scales.xAxes[0].time.isoWeekday = true;
        }
        options.scales.yAxes[0].afterFit = function (axis) {
            axis.width = 90
        }
        options.scales.xAxes[0].afterFit = function (axis) {
            axis.paddingRight = 50
        }

        return (
            <div className="MeasurementChart">
                <FullscreenWrapper reactModal={true}>
                    { loader(dataIsLoading) }
                        <Scatter
                            ref="chart"
                            options={options}
                            data={data || {}}
                            height={height}
                        />
                    {!!options && !!data && this.renderScalingControls()}
                </FullscreenWrapper>
            </div>
        );
    };

    refName = makeid();
}

const getValueOrDefault = (val, defaultValue) => {
  return isNullOrUndefined(val) ? defaultValue : val;
};

const isNullOrUndefined = (val) => {
  return val === null || val === undefined;
};

const loader = (isLoading) => {
    return <div style={{ display: isLoading ? 'block' : 'none', backgroundColor: 'grey', opacity: '0.45', textAlign: 'center', width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, zIndex: 10 }} >
        <span style={{ width: '100%', height: '100%', position: 'absolute', top: '50%', left: 0, fontSize: 'xxx-large' }}>Načítám data</span>
    </div>
}

const makeid = () => {
  let text = "";
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

export default MeasurementChart;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/Chart.js